import React, { useState } from 'react';
import { User } from 'lucide-react';

/**
 * ProfileAvatar Component
 * Displays a profile image with fallback to User icon if image fails to load
 */
const ProfileAvatar = ({ 
  src, 
  alt = 'Profile', 
  className = 'w-9 h-9',
  iconSize = 16,
  fallbackEmoji = '👤'
}) => {
  const [imageError, setImageError] = useState(false);

  if (!src || imageError) {
    return (
      <div className={`${className} rounded-full bg-gray-700 flex items-center justify-center flex-shrink-0`}>
        <User size={iconSize} className="text-gray-400" />
      </div>
    );
  }

  return (
    <img 
      src={src} 
      alt={alt} 
      className={`${className} rounded-full object-cover flex-shrink-0`}
      onError={() => setImageError(true)}
    />
  );
};

export default ProfileAvatar;
